import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/functions';

const { fbConfig } = require('./keys.js');

const firebaseConfig = {
  apiKey: fbConfig.API_KEY,
  authDomain: fbConfig.AUTH_DOMAIN,
  databaseURL: fbConfig.DATABASE_URL,
  projectId: fbConfig.PROJECT_ID,
  storageBucket: fbConfig.STORAGE_BUCKET,
  messagingSenderId: fbConfig.MESSAGING_SENDER_ID,
  appId: fbConfig.APP_ID,
};
firebase.initializeApp(firebaseConfig);
const storage = firebase.storage();
const functions = firebase.functions();
const firestore = firebase.firestore();

export { storage, firebase as default, functions, firestore };
